import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import PromoCodeManagement from './PromoCodeManagement';
import { restrictUrls } from '../../../helpers/adminPrivileges';
import messages from '../../../locale/jsonMessages';


export default async function action({ store, intl, params }) {

    const title = intl?.formatMessage(messages.manageCouponCode);

    // From Redux Store
    let isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;
    let adminPrivileges = store.getState().account.privileges && store.getState().account.privileges.privileges;
    let privileges = store.getState().listSettings && store.getState().listSettings.privileges;
    let isPromoCodeEnabled = store.getState().siteSettings && store.getState().siteSettings.data.isPromoCodeEnabled

    if (!isAdminAuthenticated) {
        return { redirect: '/siteadmin/login' };
    }

    if (!restrictUrls('/siteadmin/promo-code', adminPrivileges, privileges) || isPromoCodeEnabled == 'false') {
        return { redirect: '/siteadmin' };
    }

    return {
        title,
        component: <AdminLayout><PromoCodeManagement title={title} /></AdminLayout>,
    };
}
